import React from "react";
import SingleArticle from "../SingleArticle/SingleArticle";

export default function Recommendations({ data, title, link }) {
  return (
    <div className="recommendation_container">
      <h2>{title}</h2>
      <div className="recommendation_articles">
        {data?.map((p, i) => (
          <SingleArticle link={link} key={i} data={p} />
        ))}
      </div>
    </div>
  );
}
